import { notification } from 'antd'
import { includes } from 'lodash'
import { FORM_SUBMIT_ERROR, CLEAR_FORM_SUBMIT_ERROR } from './types'

export const showFormError = (form, error) => {
  return {
    type: FORM_SUBMIT_ERROR,
    payload: {
      form,
      error,
    },
  }
}


export const hasAuth = auth => (dispatch, getState) => {
  return includes(getState().app.userState.authorities, auth)
}
export const extractErrors = error => {
  if (error.response) {
    if (error.response.data.errors && error.response.data.errors.length > 0) {
      return error.response.data.errors.map(error => {
        return error.message
      })
    } else {
      return [error.response.data.responseMessage]
    }
  } else {
    return []
  }
}

export const showError = response => {
  let errors = extractErrors(response)
  if (errors && errors.length > 0) {
    showMessage('Request Failed', errors[0], 'error')
  }
}

export const showMessage = (title, description, type = 'success') => {
  notification.open({
    type: type,
    message: title,
    description: description,
  })
}

export const clearFormError = form => {
  return {
    type: CLEAR_FORM_SUBMIT_ERROR,
    payload: {
      form,
    },
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js